import { SubRoute } from './types';

export type NavItem = {
  route: SubRoute;
  children: NavItem[];
};

const createNavItem = (route: SubRoute, children: NavItem[] = []): NavItem => ({
  route,
  children,
});

export const createModuleNav = (
  navCreator: ($: typeof createNavItem) => NavItem,
) => navCreator(createNavItem);
